import { render, staticRenderFns } from "./manageFee.vue?vue&type=template&id=5c3980bc&"
import script from "./manageFee.vue?vue&type=script&lang=js&"
export * from "./manageFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports